import React, { useRef } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { CHIP_STYLE_TYPES } from '@CommonConstants';
import { CHOICE_KEYS } from '@Services/Editor/Constants';

import useContextMenu from '@Hooks/useContextMenu';
import useAutoComplete from '@Hooks/useAutoComplete';

import Chip from '@Components/Common/Chip';
import SnackBar from '@Components/Common/SnackBar';

import { ReactComponent as DonateSVG } from '@Assets/Svgs/ic_donate_king.svg';

import AutoComplete from '../AutoComplete';

const RequiredSponsorCookieChip = ({ processId, choiceId }) => {
  const snackBarRef = useRef(null);
  const requiredChipRef = useRef(null);
  const requiredItemRef = useRef(null);

  const { isContextMenuVisible, handleShowContextMenuClick, handleCloseContextMenuClick } = useContextMenu(
    false,
    requiredChipRef,
  );
  const {
    searchKeyword,
    propertyText,
    onDelete,
    onKeyUp,
    onAutoCompleteItemClick,
    onBlurForSponsorCookie,
    onChangeForSponsorCookie,
  } = useAutoComplete(
    snackBarRef,
    CHOICE_KEYS.REQUIRED_SPONSOR_COOKIE,
    processId,
    choiceId,
    handleCloseContextMenuClick,
  );
  return (
    <RequiredChipContainer ref={requiredChipRef}>
      <Chip
        isBorder
        chipRef={requiredItemRef}
        type={CHIP_STYLE_TYPES.ICON}
        placeholder="쿠키 후원 개수"
        value={propertyText}
        Icon={DonateSVG}
        fill="#FBA626"
        onChange={onChangeForSponsorCookie}
        onDelete={onDelete}
        onKeyUp={onKeyUp}
        onFocus={handleShowContextMenuClick}
        onBlur={onBlurForSponsorCookie}
      />

      {isContextMenuVisible && (
        <AutoComplete
          targetRef={requiredChipRef}
          isVisibleDefaultAutoComplete={false}
          isContextMenuVisible={isContextMenuVisible}
          keyword={searchKeyword}
          handleAutoCompleteItemClick={onAutoCompleteItemClick}
        />
      )}

      <SnackBar ref={snackBarRef} />
    </RequiredChipContainer>
  );
};

RequiredSponsorCookieChip.propTypes = {
  processId: PropTypes.number.isRequired,
  choiceId: PropTypes.number.isRequired,
};

const RequiredChipContainer = styled.div``;

export default RequiredSponsorCookieChip;
